// removed by extract-text-webpack-plugin
module.exports = {"sectionImg":"_1Snye7aHoy96JuTxfOfj0i","imgPrez":"_3cRxAgj2BYpavZVCDEoxOb"};


//////////////////
// WEBPACK FOOTER
// ./work/caoua/styles.module.css
// module id = 721
// module chunks = 0